const HomePage = () => import('../view/HomePage')
const Loginpwd = () => import('../view/Loginpwd')
const Loginsms = () => import('../view/Loginsms')
const Register = () => import('../view/Register')
const Resetpwd = () => import('../view/Resetpwd')
const PcAccount = () => import('../view/PcAccount')
const Error = () => import('../view/Error')
const Mobile = () => import('../view/Mobile')
const UserPage = () => import('../view/UserPage/index.vue')
const UserInfo = () => import('../view/UserPage/UserChildren/UserInfo/index.vue')
const Transaction = () => import('../view/UserPage/UserChildren/Transaction/index.vue')
const Problem = () => import('../view/UserPage/UserChildren/Problem/index.vue')

export default new VueRouter({
  routes: [{
      path: '/',
      redirect: '/homePage'
    },
    {
      path: '/homePage',
      name: 'homePage',
      component: HomePage,
      meta: {
        title: '畅由平台'
      }
    },

    {
      path: '/loginpwd',
      name: 'loginpwd',
      component: Loginpwd,
      meta: {
        title: '密码登录'
      }
    },
    {
      path: '/loginsms',
      name: 'loginsms',
      component: Loginsms,
      meta: {
        title: '短信登录'
      }
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
      meta: {
        title: '注册'
      }
    },
    {
      path: '/resetpwd',
      name: 'resetpwd',
      component: Resetpwd,
      meta: {
        title: '重置密码'
      }
    },
    {
      path: '/mobile',
      name: 'mobile',
      component: Mobile,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/pcAccount',
      name: 'pcAccount',
      component: PcAccount,
      meta: {
        title: '积分'
      }
    },
    {
      path: '/error',
      name: 'error',
      component: Error,
      meta: {
        title: '404页面'
      }
    },
    {
      path: '/userPage',
      name: 'userPage',
      component: UserPage,
      children: [{
        path: '/',
        component: UserInfo,
        name: 'userInfo',
        meta: {
          title: '我的资料'
        }
      }, {
        path: 'transaction',
        component: Transaction,
        name: 'transaction',
        meta: {
          title: '交易明细'
        }
      }, {
        path: 'problem',
        component: Problem,
        name: 'problem',
        meta: {
          title: '常见问题'
        }
      }]
    },
  ]
})
